import { render, staticRenderFns } from "./HomeOfferBlock.vue?vue&type=template&id=863ef3b2"
import script from "./HomeOfferBlock.vue?vue&type=script&lang=js"
export * from "./HomeOfferBlock.vue?vue&type=script&lang=js"
import style0 from "./HomeOfferBlock.vue?vue&type=style&index=0&id=863ef3b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports